import { Component, Input } from '@angular/core';

declare var $: any;

@Component({
    selector: 'payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent {

    @Input() info : any;

    conditionSelected = null;

    constructor( 
    ){
    }

    
  setConditionSelected(condition) {
    this.conditionSelected = condition;
    setTimeout(function () {
      $('#unitDetail').modal('show');
    }, 100);
  }

}